module.exports = __webpack_public_path__ + "media/images/flags/1x1/pak-48331de16adbf92afd4a9169e84dd387.svg";